import { type FC } from 'react';

import NextLink from 'next/link';

import MuiLink from '@mui/material/Link';

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';

import type { BreadcrumbItem } from '@/types/breadcrumb/breadcrumb.type';

export interface VMSBreadcrumbProps {
    items: BreadcrumbItem[];
}

export const VMSBreadcrumb: FC<VMSBreadcrumbProps> = ({ items }) => {
    if (items.length === 0) {
        return null;
    }

    return (
        <Breadcrumbs aria-label='breadcrumb' data-testid='vms-breadcrumbs'>
            {items.map(item => {
                const isLast = item === items[items.length - 1];

                return isLast ? (
                    <Typography
                        key={item.href}
                        color='text.primary'
                        data-testid='vms-breadcrumb-item'
                    >
                        {item.name}
                    </Typography>
                ) : (
                    <MuiLink
                        component={NextLink}
                        href={item.href}
                        key={item.href}
                        underline='hover'
                        color='inherit'
                        data-testid='vms-breadcrumb-item'
                    >
                        {item.name}
                    </MuiLink>
                );
            })}
        </Breadcrumbs>
    );
};
